import React from 'react';
import { Grip } from 'lucide-react';
import { BoardClickUpToolbarButton } from './BoardClickUpToolbarButton';
import './BoardRefreshContextMenu.css';

/** Botão "Menu" estilo ClickUp — opções da toolbar direita do Board. */
export function BoardToolbarMenuClickUpButton({
  onClick,
  disabled = false,
  isRefreshing = false,
  isOpen = false,
  isAutoRefreshEnabled = false,
  timerElementRef,
}) {
  return (
    <BoardClickUpToolbarButton
      iconOnly={!isAutoRefreshEnabled}
      icon={Grip}
      tooltip="Menu"
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      onMouseDown={(event) => {
        event.stopPropagation();
      }}
      disabled={disabled}
      isLoading={isRefreshing}
      isOpen={isOpen}
      ariaLabel="Menu"
      iconClassName="board-clickup-toolbar-menu-icon"
      className={[
        'board-clickup-toolbar-menu-btn',
        isAutoRefreshEnabled ? 'board-clickup-toolbar-menu-btn--with-timer' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isAutoRefreshEnabled ? (
        <span
          ref={timerElementRef}
          className="board-clickup-toolbar-btn-timer"
          title="Tempo para a próxima atualização automática"
        >
          04:00
        </span>
      ) : null}
    </BoardClickUpToolbarButton>
  );
}
